module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/nos-logo-44f9cc261bc3403a30068789a75d7198.svg";